import React from "react";
import { Link } from "gatsby";
import RevealAnimation from "../RevealAnimation";
import { PRACTICES as PRACTICES_DATA } from "../../data/practices";
import "./style.scss";

const PRACTICES_ICONS = {
  "/ventureryte": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    </svg>
  ),
  "/growryte": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
    </svg>
  ),
};

const PRACTICES = PRACTICES_DATA.map((p) => ({
  ...p,
  icon: PRACTICES_ICONS[p.to],
}));

const PracticesSection = () => (
  <section className="practices-section">
    <div className="body-container">
      <div className="section-header">
        <RevealAnimation
          component={"h2"}
          animation={"slide-left"}
          className="title-header mt-15 practices-heading"
        >
          <span className="red-line3letter red-3letter-mbl">Pra</span>ctices
        </RevealAnimation>
        <h3 className="practices-subheading">
          Beyond Consult, Audit, Build, Scale.
        </h3>
        <p className="subtitle">
          Two specialist practices, each drawing on all four core
          capabilities to solve a specific commercial problem.
        </p>
      </div>

      <div className="practices-grid">
        {PRACTICES.map((p, index) => (
          <RevealAnimation key={p.to} delay={0.1 + index * 0.08}>
            <Link to={p.to} className="practice-card">
              <span className="practice-card__badge">Specialist Practice</span>
              <div className="practice-card__icon">{p.icon}</div>
              <h3>{p.label}</h3>
              <p>{p.desc}</p>
              <span className="practice-card__link">
                Learn more
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12.95,12,8,16.95l1.414,1.414L15.778,12,9.414,5.636,8,7.05Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
            </Link>
          </RevealAnimation>
        ))}
      </div>
    </div>
  </section>
);

export default PracticesSection;
